// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	apiUrl: '',
	vapidPublicKey: 'BAkxtKps-bA0--wF9xivIDiQZ-3iCgHHfRLuh_38onNNRoreUX8Fhz7rd2_AjgIdwmwdLsO76OHzG8YIZiClpYQ',
	siteKey: '6LcCypEUAAAAADgdFThX3A-rioVdKvSU6GC3H-gg',
	googleApiKey: 'AIzaSyCezZlX48x8sS7DSYKldLdE-vscmfraVQw',
	siteId: null
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
